// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3lTkS","title":"InfoRow_title__3vi9O"};